/* Home — Pick a colour. Swatches recolour the bands site-wide (Dozzee.setColour), tint the section,
   pan the "in real life" photo to the child wearing that colour, swap the mood line and the mascot,
   and drive the per-colour Notify form (idle → form → done) or Add to bag in sell mode. */
(function () {
  /* Photo focus data from the reference C / FL arrays (not translatable). */
  var META = {
    cherry: { sx: 29.5, sy: 33, img: 'ice', fl: [21.7, 58.3, -33], mascot: 'red' },
    taupe: { sx: 69.5, sy: 36, img: 'ice', fl: [32.7, 51.2, -22], mascot: 'taupe' },
    pink: { sx: 90, sy: 39, img: 'ice', fl: [44.4, 48.2, -7], mascot: 'pink' },
    sunny: { sx: 49.5, sy: 34, img: 'ice', fl: [55.9, 48.3, 6], mascot: 'yellow' },
    grey: { sx: 47, sy: 64, img: 'bro', fl: [67.4, 52.1, 17], mascot: 'grey' },
    olive: { sx: 10.5, sy: 30, img: 'ice', fl: [77.3, 59.7, 29], mascot: 'green' }
  };
  var LS_NOTIFIED = 'dozzee.notified';
  var LS_EMAIL = 'dozzee.notifyEmail';

  function Colours(sec) {
    var D = window.Dozzee || {}, C = D.colours || [];
    if (!C.length) return;
    var one = function (s) { return sec.querySelector(s); };
    var q = function (s) { return Array.prototype.slice.call(sec.querySelectorAll(s)); };
    var offs = [], ctx = null, splits = [], alive = true, gs = null;
    var on = function (el, ev, fn) { if (!el) return; el.addEventListener(ev, fn); offs.push(function () { el.removeEventListener(ev, fn); }); };
    var SRC = 'home-colours';
    var sell = sec.getAttribute('data-sell') === 'true';
    var mark = sec.getAttribute('data-mark') || '%%DZ%%';
    var noTpl = sec.getAttribute('data-no-tpl') || mark;

    var namesBox = one('[data-cp-names]'), swBox = one('[data-cp-swatches]'), mood = one('[data-cp-mood]'), noEl = one('[data-cp-no]');
    var action = one('[data-cp-action]'), wrap = action && action.querySelector('[data-notify]');
    var hole = one('[data-fl-hole]'), kid = one('[data-cp-kid]'), ice = one('[data-cp-ice]'), bro = one('[data-cp-bro]'), spot = one('[data-spot]');
    var mascotBox = one('[data-cp-mascot]');

    /* ----- build names + swatches from Dozzee.colours ----- */
    var names = [], sws = [];
    C.forEach(function (c, i) {
      var n = document.createElement('div');
      n.className = 'hm-cp__name'; n.setAttribute('data-cname', ''); n.setAttribute('dir', 'ltr'); n.textContent = c.name;
      n.setAttribute('aria-hidden', 'true');
      namesBox.appendChild(n); names.push(n);
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'hm-cp__swatch'; b.style.background = c.hex;
      b.setAttribute('aria-label', c.name); b.title = c.name; b.setAttribute('aria-pressed', 'false');
      on(b, 'click', function () { pick(i); });
      swBox.appendChild(b); sws.push(b);
    });

    var idxOf = function (c) { for (var i = 0; i < C.length; i++) if (c && C[i].key === c.key) return i; return 0; };
    var cur = idxOf(D.getColour ? D.getColour() : C[0]);

    /* ----- notify memory ----- */
    var notified = {};
    try { notified = JSON.parse(D.lsGet(LS_NOTIFIED) || '{}') || {}; } catch (e) { notified = {}; }
    var lastEmail = D.lsGet ? D.lsGet(LS_EMAIL) : null;
    var setState = function (s) { if (action) action.setAttribute('data-state', s); };

    function syncAction(c) {
      q('[data-cp-name]').forEach(function (el) { el.textContent = c.name; });
      if (action) action.style.setProperty('--tick', c.hex);
      if (sell) return syncSell(c);
      if (!wrap) return;
      if (D.setNotifyTags) D.setNotifyTags(wrap, 'launch-list,' + D.tagFor(c));
      var em = notified[c.key];
      if (em) {
        var f = wrap.querySelector('form'), d = wrap.querySelector('[data-notify-done]'), er = wrap.querySelector('[data-notify-error]');
        q('[data-email]').forEach(function (el) { el.textContent = em; });
        if (f) f.hidden = true; if (d) d.hidden = false; if (er) er.hidden = true;
        wrap.classList.add('is-done');
        setState('done');
      } else {
        if (D.resetNotify) D.resetNotify(wrap);
        setState('idle');
      }
    }

    var prices = null;
    var pj = one('[data-cp-prices]');
    if (pj) { try { prices = JSON.parse(pj.textContent); } catch (e) { prices = null; } }
    var addBtn = one('[data-cp-add]'), addLink = one('[data-cp-link]'), addLabel = one('[data-cp-add-label]'), priceEl = one('[data-cp-price]');
    var addDefault = addLabel ? addLabel.textContent : '';
    function syncSell(c) {
      setState('idle');
      if (!addBtn || !addLink) return;
      if (c.variantId) {
        addBtn.hidden = false; addLink.hidden = true;
        addBtn.disabled = c.available === false;
        addBtn.setAttribute('data-variant', c.variantId);
        if (addLabel) addLabel.textContent = c.available === false ? sec.getAttribute('data-sold-out') : addDefault;
        if (priceEl) priceEl.textContent = (prices && prices[c.variantId]) || '';
      } else {
        addBtn.hidden = true; addLink.hidden = false;
        if (D.product) addLink.href = D.product;
      }
    }
    on(addBtn, 'click', function () {
      var id = addBtn.getAttribute('data-variant'); if (!id || !D.addToCart) return;
      addBtn.disabled = true;
      D.addToCart(Number(id), 1).then(function () {
        if (addLabel) addLabel.textContent = sec.getAttribute('data-added');
        setTimeout(function () { if (addLabel) addLabel.textContent = addDefault; addBtn.disabled = false; }, 2200);
      }, function () { addBtn.disabled = false; });
    });

    /* idle → form (or straight to done when we already know their email) */
    on(one('[data-cp-open]'), 'click', function () {
      if (!wrap) return;
      var input = wrap.querySelector('input[type="email"]'), form = wrap.querySelector('form');
      setState('form');
      if (lastEmail && D.validEmail && D.validEmail(lastEmail) && form) {
        if (input) input.value = lastEmail;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      } else if (input) {
        setTimeout(function () { input.focus(); }, 30);
      }
    });
    on(wrap, 'dozzee:notified', function (e) {
      var em = e.detail && e.detail.email, c = C[cur], tags = String((e.detail && e.detail.tags) || '').split(',');
      if (!em) return;
      C.forEach(function (x) { if (tags.indexOf(D.tagFor(x)) >= 0) c = x; });
      notified[c.key] = em; lastEmail = em;
      if (D.lsSet) { D.lsSet(LS_NOTIFIED, JSON.stringify(notified)); D.lsSet(LS_EMAIL, em); }
      setState('done');
    });

    /* ----- apply a colour ----- */
    var mascotWant = null, mascotT = null;
    offs.push(function () { clearTimeout(mascotT); });
    function mascot(c) {
      mascotWant = META[c.key] ? META[c.key].mascot : 'red';
      clearTimeout(mascotT);
      var n = 0;
      (function go() {
        var m = mascotBox && mascotBox.querySelector('[data-mascot]');
        if (!m || !alive) return;
        if (window.DozzeeMascot && window.DozzeeMascot.set) { window.DozzeeMascot.set(m, mascotWant); return; }
        if (n++ < 100) mascotT = setTimeout(go, 100); // mascot.js loads after this script
      })();
    }

    function apply(i, instant) {
      var c = C[i], m = META[c.key] || META.cherry, prev = cur, d = instant ? 0 : 1, f = m.fl;
      if (mood) { mood.textContent = c.mood; mood.style.color = c.deep; }
      if (noEl) noEl.textContent = noTpl.split(mark).join(c.no);
      sws.forEach(function (b, k) {
        b.style.boxShadow = k === i ? '0 0 0 4px ' + c.tint + ', 0 0 0 6px #26301F' : 'inset 0 -5px 10px rgba(0,0,0,.18)';
        b.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      names.forEach(function (n, k) { n.classList.toggle('is-on', k === i); n.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      mascot(c);
      if (prev !== i || instant) syncAction(c);

      if (gs) {
        gs.to(sec, { backgroundColor: c.tint, duration: 0.8 * d, ease: 'power2.out' });
        gs.to(spot, { '--sx': m.sx + '%', '--sy': m.sy + '%', duration: 0.9 * d, ease: 'power3.inOut' });
        gs.to(ice, { opacity: m.img === 'ice' ? 1 : 0, duration: 0.5 * d });
        gs.to(bro, { opacity: m.img === 'bro' ? 1 : 0, duration: 0.5 * d });
        if (hole) gs.to(hole, { left: f[0] + '%', top: f[1] + '%', rotation: f[2], duration: 0.85 * d, ease: 'power3.inOut' });
        if (instant || prev === i) gs.set(splits[i].chars, { yPercent: 0 });
        else {
          gs.killTweensOf(splits[prev].chars.concat(splits[i].chars));
          gs.to(splits[prev].chars, { yPercent: -110, duration: 0.35, stagger: 0.012, ease: 'power2.in' });
          gs.fromTo(splits[i].chars, { yPercent: 110 }, { yPercent: 0, duration: 0.7, stagger: 0.022, ease: 'back.out(1.4)', delay: 0.12 });
          if (kid) gs.fromTo(kid, { scale: 0.95 }, { scale: 1, duration: 0.7, ease: 'back.out(2.2)' });
        }
      } else {
        sec.style.backgroundColor = c.tint;
        if (spot) { spot.style.setProperty('--sx', m.sx + '%'); spot.style.setProperty('--sy', m.sy + '%'); }
        if (ice) ice.style.opacity = m.img === 'ice' ? 1 : 0;
        if (bro) bro.style.opacity = m.img === 'bro' ? 1 : 0;
        if (hole) { hole.style.left = f[0] + '%'; hole.style.top = f[1] + '%'; hole.style.transform = 'rotate(' + f[2] + 'deg)'; }
      }
      cur = i;
    }

    function pick(i) {
      if (i === cur) return;
      apply(i, false);
      if (D.setColour) D.setColour(C[i].key, SRC);
    }
    on(document, 'dozzee:colour', function (e) {
      if (!e.detail || e.detail.source === SRC || !e.detail.colour) return;
      var i = idxOf(e.detail.colour); if (i !== cur) apply(i, false);
    });

    apply(cur, true);

    if (!D.reduce && D.gsap) D.gsap(function (gsap, ST, Split) {
      if (!alive) return;
      ctx = gsap.context(function () {
        splits = names.map(function (n) { var sp = Split.create(n, { type: 'chars', mask: 'chars' }); return sp; });
        splits.forEach(function (sp) { gsap.set(sp.chars, { yPercent: 110 }); });
        namesBox.classList.add('is-split');
        gs = gsap;
        apply(cur, true);
      }, sec);
    });

    this.destroy = function () {
      alive = false;
      offs.forEach(function (f) { try { f(); } catch (e) {} });
      if (ctx) ctx.revert();
      splits.forEach(function (s) { try { s.revert(); } catch (e) {} });
      names.forEach(function (n) { n.remove(); }); sws.forEach(function (b) { b.remove(); });
    };
  }

  function init(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-section-type="home-colours"]')).forEach(function (sec) {
      if (!sec._hmCp) sec._hmCp = new Colours(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll('[data-section-type="home-colours"]')).forEach(function (sec) {
      if (sec._hmCp && sec._hmCp.destroy) sec._hmCp.destroy();
      sec._hmCp = null;
    });
  });
})();
